import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type ImportationsTableMessages = TableColumnsMessages &
  PopoverMessages & {
    importationNotFoundError: string;
    importationNotFoundDescription: string;
    importationNotFoundAlt: string;
    importationErrorToLoad: string;
    importationTableTitle: string;
    dateColumn: string;
    typeColumn: string;
    fileNameColumn: string;
    statusColumn: string;
    successColumn: string;
    errorColumn: string;
    optionsColumn: string;
  };

export const IMPORTATIONS_TABLE_MESSAGES: ImportationsTableMessages = {
  ...TABLE_COLUMNS_MESSAGES,
  importationNotFoundError: "Importação não encontrada",
  importationNotFoundDescription: "Descrição da importação não encontrada",
  importationNotFoundAlt: "Importação não encontrada alternativa",
  importationErrorToLoad: "Erro ao carregar importações",
  importationTableTitle: "Listagem de Importações",
  dateColumn: "Data",
  typeColumn: "Tipo",
  fileNameColumn: "Arquivo",
  statusColumn: "Status",
  successColumn: "Sucesso",
  errorColumn: "Erro",
  optionsColumn: "Opções",
  ...POPOVER_MESSAGES,
};

export default IMPORTATIONS_TABLE_MESSAGES;
